import { render, staticRenderFns } from "./MariaBucci.vue?vue&type=template&id=19a478a8"
import script from "./MariaBucci.vue?vue&type=script&lang=js"
export * from "./MariaBucci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports